import Vue from 'vue'
import App from './App.vue'
import Vuex from "vuex"
import '@mdi/font/css/materialdesignicons.css'
import VueRouter from "vue-router";
//my route file
import router from './router'
//my route file
import store from './store'

import vueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import '@babel/polyfill'
import MultiFiltersPlugin from './plugins/MultiFilters'

import Clipboard from "v-clipboard";

import axios from 'axios'


import fullscreen from 'vue-fullscreen'

import VueSimpleAlert from "vue-simple-alert";

import Carousel3d from 'vue-carousel-3d';

import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'


import Bars from 'vuebars'

import VueTabsChrome from 'vue-tabs-chrome'
Vue.use(VueTabsChrome)


import GoogleAuth from '@/config/google_auth.js'
const gauthOption = {
  clientId: '332968106269-a21t1904budahu2npa3mf55bko6aikma.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GoogleAuth, gauthOption)






import "@google/model-viewer/dist/model-viewer.js";

// import vb from 'vue-babylonjs';
// Vue.use(vb);

//import 'babylonjs-viewer';

import "@babylonjs/core"



//import * as BabylonViewer from '@babylonjs/viewer';
// import * as BabylonViewer from '@babylonjs/viewer';
// BabylonViewer.InitTags('babylon');
// Vue.use(BabylonViewer);

import '@babylonjs/viewer';
import "@babylonjs/core/Debug/debugLayer";
import "@babylonjs/inspector";
import "@babylonjs/loaders/glTF";


import VueAnalytics from 'vue-analytics';

import movable from "v-movable";


//global variables
Vue.prototype.$abServerPath = ""


////Vue.use('babylon', require('@babylonjs/viewer'));

/*import {
  ModelViewerElement
} from "@google/model-viewer/dist/model-viewer.js"; */

//import gltfPipeline from "gltf-pipeline";
//import fsExtra from "fs-extra";


import vuetify from './plugins/vuetify';
//Added Plugin
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
//Added Plugin


// import * as BABYLON from 'babylonjs';
// Vue.use(BABYLON);


//import "babylonjs-viewer/babylon.viewer.js";


import {
  showAt,
  hideAt
} from 'vue-breakpoints'


// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";


import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import 'material-design-icons-iconfont/dist/material-design-icons.css'



Vue.config.productionTip = false
//Vue.use(modelviewer);

//Vue.use(gltfPipeline);
//Vue.use(fsExtra);


Vue.use(Carousel3d);

Vue.use(Splitpanes);
Vue.use(Pane);

Vue.use(axios);
Vue.use(fullscreen);
Vue.use(VueSimpleAlert);
Vue.use(showAt);
Vue.use(hideAt);
Vue.use(vueDropzone);
Vue.use(MultiFiltersPlugin);
//Vue.use(ModelViewerElement);
Vue.use(Vuex);

//latest added
Vue.prototype.$Chartist = Chartist;
Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);

Vue.use(VueMaterial);
//latest added

Vue.use(movable);


Vue.use(Clipboard);


Vue.use(Bars)

// Configuration VueAnalytics
const isProduction = process.env.NODE_ENV === 'production'
// id: 'UA-126819472-2',
console.log("yess")
console.log(isProduction)
Vue.use(VueAnalytics, {
    id: 'UA-186273566-1',
    router,
    debug: {
      enabled: !isProduction,
      sendHitTask: isProduction
    }
    
});


// configure router
//const routerr = new VueRouter({
//router, // short for routes: routes
//linkExactActiveClass: "nav-item active"
//});


new Vue({
  router,
  store,
  vuetify,
  data: {
    Chartist: Chartist
  },
  render: h => h(App),

}).$mount('#app')


